export function defineCustomTags(tagName, extendsNodeType, tagsCollection) {
    let classes = true;
    if (typeof customElements !== "undefined" && customElements.get(tagName) === undefined) {
        try {
            eval("class foo{ constructor(){} }");
        }
        catch (e) {
            classes = false;
        }
        const extendsNodeTypeClass = getExtendsNodeTypeClass(extendsNodeType);
        if (classes) {
            eval(`window.customElements.define("${tagName}", class extends ${extendsNodeTypeClass} { })`);
        }
        else {
            eval(`window.customElements.define("${tagName}", ${extendsNodeTypeClass})`);
        }
        if (typeof tagsCollection === "object") {
            tagsCollection[tagName] = extendsNodeTypeClass;
        }
    }
    return true;
}
function getExtendsNodeTypeClass(extendsNodeType) {
    return typeof extendsNodeType === "string" && extendsNodeType.length > 0 ? extendsNodeType : "HTMLElement";
}
//# sourceMappingURL=defineCustomTags.js.map